// extracted by css-extract-rspack-plugin
export default {"root":"root-pnIQ1H","selected":"selected-UOJJEu","radio":"radio-vqpDsV"};